import { IconReceipt2 } from '@tabler/icons';
import {
  Button,
  Modal,
  ModalBody,
  ModalDescription,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  Usd,
} from '#root/components/ui';
import type { OneTotals } from './oneOrder';
import styles from './oneOrderCard.module.scss';

interface OneTotalDialogProps {
  open: boolean;
  onClose: () => void;
  /** Nombre del producto */
  title?: string;
  totals: OneTotals;
}

/** Qué compone el total que pagó el comprador por un pedido ONE */
const OneTotalDialog = ({ open, onClose, title, totals }: OneTotalDialogProps) => (
  <Modal open={open} onClose={onClose} size="sm">
    <ModalHeader icon={<IconReceipt2 />} tone="info">
      <ModalTitle>Detalle del total pagado</ModalTitle>
      {title && <ModalDescription>{title}</ModalDescription>}
    </ModalHeader>
    <ModalBody>
      <table className={styles.breakdown}>
        <tbody>
          <tr>
            <th scope="row">Precio + impuestos</th>
            <td>
              <Usd value={totals.price} />
            </td>
          </tr>
          <tr>
            <th scope="row">Viajero</th>
            <td>
              <Usd value={totals.traveler} />
            </td>
          </tr>
          <tr>
            <th scope="row">Guvery</th>
            <td>
              <Usd value={totals.guvery} />
            </td>
          </tr>
          {totals.discount > 0 && (
            <tr className={styles.discount}>
              <th scope="row">Descuento cupón</th>
              <td>
                −<Usd value={totals.discount} />
              </td>
            </tr>
          )}
        </tbody>
        <tfoot>
          <tr>
            <th scope="row">Total pagado</th>
            <td>
              <Usd value={totals.total} />
            </td>
          </tr>
        </tfoot>
      </table>
    </ModalBody>
    <ModalFooter>
      <Button onClick={onClose}>Entendido</Button>
    </ModalFooter>
  </Modal>
);

export default OneTotalDialog;
